import { TodoType } from "@acto/gql/graphql";

export const MANAGEMENT_TODO_TYPES = [TodoType.Workflow, TodoType.NoteBased, TodoType.Manual];
